<template>
  <account-dropdown
      :selected-iban="selectedIban"
      show-pending-count
      @onAccountChange="onAccountChange"
  />
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { usePendingPaymentStore } from '@account/store/pendingPaymentStore'
import AccountDropdown from '@account/components/AccountDropdown.vue'

export default {
  name: 'pending-account-filter',
  components: { AccountDropdown },
  methods: {
    ...mapActions(usePendingPaymentStore, ['setSelectedIban', 'searchPendingPayments']),
    onAccountChange (account) {
      this.setSelectedIban(account.iban)
      this.searchPendingPayments()
    }
  },
  computed: {
    ...mapState(usePendingPaymentStore, ['selectedIban'])
  }
}
</script>
